module.exports = __webpack_public_path__ + "static/digi-6fd6eec7ee0d72c7261449b5cc6d562c.png";